$bog_blitz_lobby_host $mol_page
	Head null
	counter_string \
	land_id \
	quiz_title \
	session null
	quiz_data null
	body /
		<= Qr $bog_qr
			uri <= qr_data \
			error_correction \M
			center /
				<= Logo $mol_image
					uri \bog/blitz/assets/logo.svg
			module_radius 0.35
			finder_radius 1.2
			gradient_angle 125
			gradient_stops /
				\var(--mol_theme_special)
				\var(--mol_theme_current)
		<= Quiz_title $mol_paragraph
			title <= quiz_title
		<= Land_id $mol_paragraph
			title <= land_id
		<= Start $mol_button_major
			title @ \Start Game!
			click? <=> start? null
		<= Counter $mol_paragraph
			title <= counter_string
		<= Players $bog_blitz_lobby_players
	Foot null
	sub /
		^
